export const contractor_role_id = "7f3a9e12-98c2-4c6a-9a6a-22bcdaf001a1";
export const super_admin_role_id = "5c1e7d44-4b2b-42df-917b-6c89e3d0c231";

export const admin_role_id = "a92f3d18-0c9f-4af3-b8b3-13b2c79c44e2";

export const profile_url = process.env.REACT_APP_API_URL + "/public/uploads/profile/";

export const react_app = "https://portal.jobsiterating.com";
export const next_app = "https://jobsiterating.com";

export const issueLabels = {
	"unclear-expectations": "Unclear expectations",
	"scope-changed": "Scope changed mid-job",
	"payment-delayed": "Payment delayed",
	"verbal-aggression": "Verbal aggression",
	"threatened-review": "Threatened bad review",
	"access-issues": "Access issues",
	"micromanaged": "Client micromanaged",
	"safety-concerns": "Safety concerns",
	"poor-communication": "Poor communication",
	other: "Other",
};

export const jobIssuesOptions = [
	{id: "unclear-expectations", label: "Unclear expectations"},
	{id: "scope-changed", label: "Scope changed mid-job"},
	{id: "payment-delayed", label: "Payment delayed"},
	{id: "verbal-aggression", label: "Verbal aggression"},
	{id: "threatened-review", label: "Threatened bad review"},
	{id: "access-issues", label: "Access issues (e.g. locked out, reschedules)"},
	{id: "micromanaged", label: "Client micromanaged"},
	{id: "safety-concerns", label: "Safety concerns"},
	{id: "poor-communication", label: "Poor communication"},
	{id: "other", label: "Other"},
];
